import Stats from "./Stats";
import Numbered from "./Numbered";
import Features from "./Features";
import Pills from "./Pills";

/**
 * @typedef {import("@prismicio/client").Content.TextGridSlice} TextGridSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<TextGridSlice>} TextGridProps
 * @param {TextGridProps}
 */
const TextGrid = ({ slice: { variation, primary, items } }) => {
	switch (variation) {
		case "stats":
			return <Stats primary={primary} items={items} />;
		case "numbered":
			return <Numbered primary={primary} items={items} />;
		case "features":
			return <Features primary={primary} items={items} />;
		case "pills":
			return <Pills primary={primary} items={items} />;
		default:
			return null;
	}
};

export default TextGrid;
